export default "__VITE_ASSET__Bm22Yeu7__"